module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_hokkaido-309b34f1f47cc53ccf69812ecaf1d2df.png";